import { useCallback } from 'react'
import { processAiToolPayment } from '../utils/aiTool/payment'

export function useAiToolPayment() {
  const initiatePayment = useCallback(
    (params) => processAiToolPayment(params),
    [],
  )

  return { initiatePayment }
}
